import './App.css';
import Navbar from './components/global/Navbar';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './components/home/Home';
import Login from './components/login/Login';
import SignUp from './components/login/SignUp';
import ForgetPassword from './components/login/ForgetPassword';
import { useEffect, useState } from 'react';
import { Auth } from 'aws-amplify';
import { User } from './utils/interfaces';
import { config } from './config';
import { databaseName } from './utils/constants';
import ResourceDev from './components/resource/ResourceDev';
import PageNotFound from './components/PageNotFound/PageNotFound';
import Footer from './components/global/Footer';

function App() {

  const [user, setUser] = useState<undefined | null | User>(undefined);

  // get current user
  useEffect(() => {
    (async () => {
      try {
        const cogUser = await Auth.currentAuthenticatedUser();
        const res = await (await fetch(`${config.api.database}?table=${databaseName}_users&key=username&value=${cogUser.username.toLowerCase()}`)).json();
        setUser(res);
      } catch (error) {
        // No user authenticated
        setUser(null);
      }
    })();
  }, []);

  return (
    <div className='app bg-neutral-900 flex flex-col h-svh'>
      <BrowserRouter>
        <Navbar user={user} setUser={setUser} />
        <Routes>
          <Route path='/' element={<Home user={user} setUser={setUser} />} />
          {/* auth */}
          <Route path='/login' element={<Login user={user} setUser={setUser} />} />
          <Route path='/sign-up' element={<SignUp user={user} setUser={setUser} />} />
          <Route path='/forget-password' element={<ForgetPassword user={user} />} />
          {/* resource */}
          <Route path='/resources/:id' element={<ResourceDev user={user} setUser={setUser} />} />
          {/* page not found */}
          <Route path='/page-not-found' element={<PageNotFound />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
